module.exports = __webpack_public_path__ + "static/media/raven_funny_04.aa423859.svg";